import api from '@pray/shared/utils/api';

export type ActivateMarketingCampaignParams = {
  artistId: string;
  campaignId: string;
  /** Ongoing campaigns only — time_bound dailies are computed server-side from the grossed total. */
  dailyBudgetCents?: number;
};

export const activateMarketingCampaign = async ({
  artistId,
  campaignId,
  dailyBudgetCents,
}: ActivateMarketingCampaignParams) => {
  const url = `/web/studio/artists/${artistId}/marketing-campaigns/${campaignId}/activate`;

  const body: Record<string, unknown> = {};

  if (dailyBudgetCents !== undefined) body.daily_budget_cents = dailyBudgetCents;

  const response = await api.executePostRequest(url, body);

  return response.data;
};
